import React, { useState } from 'react';
import { NavLink, Outlet, useLocation } from 'react-router-dom';
import { PageTitle } from 'components/shared';
import * as routes from 'constants/routes';

const sidebarSections = [
  {
    title: 'DASHBOARD',
    links: [
      { to: routes.DASHBOARD, label: 'Overview' },
    ]
  },
  {
    title: 'ACCOUNT',
    links: [
      { to: routes.PROFILE, label: 'Profile' },
      { to: routes.ADDRESSES, label: 'Addresses' },
      { to: routes.SECURITY, label: 'Security' },
      { to: routes.PREFERENCES, label: 'Preferences' },
    ]
  },
  {
    title: 'SHOPPING',
    links: [
      { to: routes.ORDERS, label: 'Orders' },
      { to: routes.WISHLIST, label: 'Wishlist' },
      { to: routes.RECENTLY_VIEWED, label: 'Recently Viewed' },
      { to: routes.RECOMMENDATIONS, label: 'Recommendations' },
    ]
  },
  {
    title: 'FINANCE & LOYALTY',
    links: [
      { to: routes.PAYMENTS, label: 'Payments' },
      { to: routes.RETURNS, label: 'Returns' },
      { to: routes.LOYALTY, label: 'Loyalty & Rewards' },
    ]
  },
  {
    title: 'COMMUNICATION & EXTRAS',
    links: [
      { to: routes.COMMUNICATION, label: 'Communication' },
      { to: routes.SUBSCRIPTIONS, label: 'Subscriptions' },
      { to: routes.REVIEWS, label: 'Reviews' },
      { to: routes.DOWNLOADS, label: 'Downloads' },
      { to: routes.BUSINESS_ACCOUNT, label: 'Business Accounts' },
      { to: routes.ADDITIONAL_FEATURES, label: 'Additional Features' },
    ]
  },
];

function AccountLayout() {
  const location = useLocation();
  const [expandedSections, setExpandedSections] = useState(() => {
    const initial = {};
    sidebarSections.forEach((section, idx) => {
      initial[idx] = section.links.some(l => location.pathname.startsWith(l.to));
    });
    return initial;
  });

  const toggleSection = (idx) => {
    setExpandedSections(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  return (
    <>
      <PageTitle title='My Account' />
      <div className='content-wrap pt-lg-5 pb-lg-5 py-4 my-lg-3'>
        <div className='container'>
          <div className='row'>
            {/* Sidebar Navigation */}
            <div className='col-lg-3 col-md-4 mb-4'>
              <div className='card border border-size-md p-0 rounded-10'>
                {sidebarSections.map((section, idx) => (
                  <div key={idx} className={`${idx !== sidebarSections.length - 1 ? 'border-bottom' : ''}`}>
                    <h6 
                      className='font-xssss ls-3 fw-700 text-grey-500 bg-greylight py-3 px-4 mb-0 text-uppercase d-flex justify-content-between align-items-center'
                      style={{ cursor: 'pointer' }}
                      onClick={() => toggleSection(idx)}
                    >
                      {section.title}
                      <i className={`feather-chevron-${expandedSections[idx] ? 'up' : 'down'} font-xssss`}></i>
                    </h6>
                    {expandedSections[idx] && (
                      <ul className='list-unstyled mb-0 py-2'>
                        {section.links.map((link, lidx) => (
                          <li key={lidx}>
                            <NavLink
                              to={link.to}
                              className={({ isActive }) =>
                                `d-block py-2 px-4 font-xssss fw-600 ${isActive ? 'text-current bg-light' : 'text-grey-700 hover-bg-light'}`
                              }
                            >
                              {link.label}
                            </NavLink>
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ))}
              </div>
            </div>

            {/* Main Content Area */}
            <div className='col-lg-9 col-md-8'>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AccountLayout;
